
import { Component, Prop, Watch, Emit, FormComponentBase } from "@/lib";
@Component({ name: "hi-input-number" })
export default class HiInputNumber extends FormComponentBase {
  @Prop({ type: Number, default: null }) value: number;
  @Prop({ type: Number, default: 2 }) precision: number; //数值精度
  @Prop({ type: Number, default: 0 }) min: number; //最小值
  @Prop({ type: Number, default: 9999999 }) max: number; //最大值
  @Prop({ type: String, default: "" }) unitText: string; //格式化 拼接单位
  @Prop({ type: Function }) formatter: Function; //指定输入框展示值的格式
  @Prop({ type: Function }) parser: Function; //指定从 formatter 里转换回数字的方式，和 formatter 搭配使用

  get requiredRule() {
    return {
      type: "number",
      required: true, //是否必填
      message: this.L("Validate.PleaseInput", this.L(this.labelKey)), //验证信息
      trigger: "blur", //触发方式    常用  blur 和 change}
    };
  }

  @Emit("on-change")
  change() {
    this.$emit("change");
  }

  get formatterFunction(): Function {
    if ("" !== this.unitText) {
      return (value) => `${value}${this.unitText}`;
    }
    return this.formatter;
  }
  get parserFunction(): Function {
    if ("" !== this.unitText) {
      return (value) => value.replace(this.unitText, "");
    }
    return this.parser;
  }
}
